import React from "react";

import { addUtmParamsToLinksAndPageNavigators } from "../../../Common/utils/NavigationUtils";
import { useValidateQueryParams } from "../../../Common/utils/hooks/QueryParams/useValidateQueryParams";

import Image from "../Image";
import "./FooterDark.css";

const INTENSIVE_LOGO =
  "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english/nxtwave-intensive-logo.svg";

export default function FooterDark() {
  const verifiedUtm = useValidateQueryParams();
  return (
    <footer className="footer footer-dark">
      <div className="div_block_183198052z footer-dark__inner">
        <a
          id="nxtwave-logo-footer"
          referrerPolicy="no-referrer-when-downgrade"
          href={addUtmParamsToLinksAndPageNavigators(
            verifiedUtm,
            "https://www.ccbp.in/"
          )}
          className="w_inline_block"
          style={{ marginBottom: "auto" }}
        >
          <Image
            width={117}
            height={32}
            alt="NxtWave Intensive"
            src={INTENSIVE_LOGO}
            loading="lazy"
            className="image_8128822196 footer-dark__logo"
          />
        </a>
        <nav className="navigation footer-dark__nav">
          <a
            id="privacy-policy-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/privacy-policy"
            )}
            className="link"
          >
            Privacy Policy
          </a>
          <a
            id="cookie-policy-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/cookie-policy"
            )}
            className="link"
          >
            Cookie Policy
          </a>
          <a
            id="terms-and-conditions-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/terms-and-conditions"
            )}
            className="link"
          >
            Terms &amp; Conditions
          </a>
          <a
            id="grievance-redressal-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/grievance-redressal"
            )}
            className="link"
          >
            Grievance Redressal
          </a>
          <a
            id="corporate-information-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/corporate-information"
            )}
            className="link"
          >
            Corporate Information
          </a>
        </nav>
      </div>
    </footer>
  );
}
